function waitForDevConsole(cb, timeout = 3000) {
  const start = Date.now();

  (function tick() {
    if (window.WCCP_DEV_CONSOLE && typeof window.WCCP_DEV_CONSOLE.log === 'function') {
      cb();
      return;
    }
    if (Date.now() - start > timeout) {
      return;
    }
    setTimeout(tick, 30);
  })();
}



const applyVisibilityFrom = (() => {
        let deferredFromIndex = null;
        let timer = null;

        const isLoading = () => {
            try { return !!(window.WCCP_LOADING && typeof WCCP_LOADING.active === 'function' && WCCP_LOADING.active()); }
            catch { return false; }
        };

        const run = (fromIndex) => {
            const steps = qsa(selFor(CLASSES.step), root);
            const allowedByComp = computeAllowedByComponent();


            // DEV: Log state update
            function getStateSnapshot() {
                return {
                    selected: { ...STATE.selected },
                    selectedVariants: { ...STATE.selectedVariants },
                    selectedQty: { ...STATE.selectedQty }
                };
            }

            if (window.WCCP_DEV_MODE?.debug?.stateInfo) {
                const devlog = window.WCCP_DEV_CONSOLE?.log || console.log;
                waitForDevConsole(() => {
                    window.WCCP_DEV_CONSOLE.log("STATE_INFO", {
                        state: getStateSnapshot(),
                        data: {
                            product_id: STATE.data?.product_id,
                            components_count: STATE.data?.components?.length || 0,
                            scenarios_count: STATE.data?.scenarios?.length || 0,
                            component_ids: STATE.data?.components?.map(c => c.id),
                            scenario_ids: STATE.data?.scenarios?.map(s => s.id || s.scenario_id)
                        },
                    });
                });
            }

            for (let i = fromIndex + 1; i < steps.length; i++) {
                const stepEl = steps[i];

                if (stepEl.classList.contains('accessories-step') || Number(stepEl.dataset.item_id) === STATE.accessories_step_id) {
                    qsa(selFor(CLASSES.li), stepEl).forEach(li => {
                        li.style.display = '';
                    });
                    if (stepEl.dataset.step === '1') stepEl.style.display = 'block';
                    continue;
                }

                const compIdOfStep = Number(stepEl.dataset.item_id);
                const allowedSet = allowedByComp.get(compIdOfStep) || new Set();

                const optionEls = qsa(selFor(CLASSES.option), stepEl);
                let anyVisible = false;

                optionEls.forEach(opt => {
                    const pid = Number(opt.dataset.productId);
                    const li  = opt.closest(selFor(CLASSES.li));
                    // DEV MODE: ignore hiding - show all options
                    // const show = allowedSet.has(pid);

                    // if (li) li.style.display = show ? '' : 'none';
                    // if (show) anyVisible = true;

                    // if (devIgnore) {
                    //     if (li) li.style.display = '';
                    //     anyVisible = true;
                    // } else {
                    //     const show = allowedSet.has(pid);
                    //     if (li) li.style.display = show ? '' : 'none';
                    //     if (show) anyVisible = true;
                    // }

                    // DEV MODE: scenario-hidden - show options but disabled
                    // if (devIgnore && !allowedSet.size) {
                    //     if (li) li.style.display = '';
                    //     anyVisible = true;
                    //     return;
                    // }

                    const show = allowedSet.has(pid);
                    if (li) li.style.display = show ? '' : 'none';
                    if (show) anyVisible = true;

                    if (STATE.selected[compIdOfStep] != null && STATE.selected[compIdOfStep] === pid && !show) {
                        delete STATE.selected[compIdOfStep];
                        optionEls.forEach(o => o.classList.remove(CLASSES.selected));
                    }
                });

                stepEl.style.display = anyVisible ? (stepEl.dataset.step === '1' ? 'block' : stepEl.style.display) : 'none';
            }
        };

        const schedule = (fromIndex) => {
            deferredFromIndex = deferredFromIndex == null ? fromIndex : Math.min(deferredFromIndex, fromIndex);
            if (timer) return;

            const tick = () => {
                if (isLoading()) {
                    timer = setTimeout(tick, 60);
                    return;
                }
                const idx = deferredFromIndex == null ? fromIndex : deferredFromIndex;
                deferredFromIndex = null;
                timer = null;
                run(idx);
            };

            timer = setTimeout(tick, 60);
        };

        return (fromIndex) => {
            if (isLoading()) {
                schedule(fromIndex);
                return;
            }
            run(fromIndex);
        };
    })();